<div class="container py-4">
  <div class="mb-4">
    <button class="btn btn-link text-decoration-none p-0 mb-3" (click)="goBack()">
      <fa-icon [icon]="faArrowLeft" class="me-1"></fa-icon> Zurück zur Übersicht
    </button>
  </div>

  <div *ngIf="notification$ | async as notification; else loading" class="card shadow">
    <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <div class="me-3 d-flex align-items-center justify-content-center bg-light rounded-circle" style="width: 40px; height: 40px;">
          <fa-icon [icon]="getIconForType(notification.type)" size="lg" [class]="getPriorityClass(notification.priority)"></fa-icon>
        </div>
        <h2 class="h4 mb-0">{{ notification.title }}</h2>
      </div>
      <span class="badge" [ngClass]="getStatusClass(notification.status)">
        {{ notification.status }}
      </span>
    </div>

    <div class="card-body py-4">
      <div class="mb-4">
        <p class="lead text-dark">{{ notification.message }}</p>
      </div>

      <div class="row mb-4">
        <div class="col-md-6">
          <h6 class="text-muted small text-uppercase fw-bold">Details</h6>
          <ul class="list-unstyled">
            <li class="mb-2">
              <span class="text-muted">Erstellt am:</span> {{ notification.createdAt | date:'dd.MM.yyyy HH:mm' }}
            </li>
            <li class="mb-2" *ngIf="notification.readAt">
              <span class="text-muted">Gelesen am:</span> {{ notification.readAt | date:'dd.MM.yyyy HH:mm' }}
            </li>
            <li class="mb-2" *ngIf="notification.dueDate">
              <span class="text-muted text-danger fw-bold">Fälligkeit:</span> {{ notification.dueDate | date:'dd.MM.yyyy HH:mm' }}
            </li>
            <li class="mb-2" *ngIf="notification.reminderAt">
              <span class="text-muted text-warning">Erinnerung:</span> {{ notification.reminderAt | date:'dd.MM.yyyy HH:mm' }}
            </li>
            <li class="mb-2">
              <span class="text-muted">Typ:</span> {{ notification.type }}
            </li>
            <li class="mb-2">
              <span class="text-muted">Priorität:</span> {{ notification.priority }}
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <h6 class="text-muted small text-uppercase fw-bold">Kanäle</h6>
          <div class="d-flex flex-wrap gap-2">
            <span *ngFor="let channel of notification.channels" class="badge bg-light text-dark border">
              <i class="fas fa-satellite-dish small me-1"></i> {{ channel }}
            </span>
          </div>
        </div>
      </div>

      <div class="d-flex gap-3 mt-4" *ngIf="notification.internalLink || notification.externalLink || notification.actions?.length">
        <a *ngIf="notification.internalLink" [routerLink]="notification.internalLink" class="btn btn-primary">
          Aktion ausführen (Intern)
        </a>
        <a *ngIf="notification.externalLink" [href]="notification.externalLink" target="_blank" class="btn btn-outline-primary">
          Link öffnen (Extern) <fa-icon [icon]="faExternalLink" class="ms-1 small"></fa-icon>
        </a>
        <button *ngFor="let action of notification.actions"
                class="btn btn-outline-primary"
                (click)="handleAction(notification, action)">
          <fa-icon *ngIf="action.icon" [icon]="actionIcons[action.icon]" class="me-1"></fa-icon>
          {{ action.label }}
        </button>
      </div>
    </div>

    <div class="card-footer bg-light py-3">
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-outline-secondary" (click)="setReminder(notification.id)">
          <fa-icon [icon]="faClock" class="me-1"></fa-icon> Erinnerung
        </button>
        <button class="btn btn-outline-secondary" (click)="archive(notification.id)">
          <fa-icon [icon]="faArchive" class="me-1"></fa-icon> Archivieren
        </button>
        <button *ngIf="notification.status === 'UNREAD'" class="btn btn-success" (click)="markAsRead(notification.id)">
          <fa-icon [icon]="faCheck" class="me-1"></fa-icon> Als gelesen markieren
        </button>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Laden...</span>
      </div>
      <p class="mt-2 text-muted">Benachrichtigung wird geladen...</p>
    </div>
  </ng-template>
</div>
